import * as angular from 'angular';

import { ComponentDefinition, IApprovalStrategy, ApplicationUserViewModel } from '../../../models';
import { ICurrentApplicationService, IRolesService, IAuthorizationService, ILoggerService, IapplicationUserService } from '../../../services';
import { superAdminRole, toggleEditMode, strategySaved } from '../../../common';

class ApprovalStrategiesController implements angular.IComponentController {

    canEdit: boolean;
    contextualFormController: angular.IFormController;
    formController: angular.IFormController;
    isEditMode: boolean;
    isLoading: boolean;
    roles: { id: string, name: string }[];
    selectedStrategy: IApprovalStrategy;
    users: ApplicationUserViewModel[];

    private _pristine: IApprovalStrategy;

    static $inject = [
        '$scope',
        'applicationUserService',
        'currentApplicationService',
        'rolesService',
        'authorizationService',
        'loggerService'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _applicationUserService: IapplicationUserService,
        private _currentApplicationService: ICurrentApplicationService,
        private _rolesService: IRolesService,
        private _authorizationService: IAuthorizationService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        const config = this._currentApplicationService.getApplicationConfiguration();
        const appGuid = config.guid;
        this._applicationUserService.getUsers(appGuid)
            .then(users => {
                this.users = users;
            });
        this._rolesService.getAll()
            .then(data => this.roles = data.filter(d => d.name.toLowerCase() !== superAdminRole));
        this.canEdit = this._authorizationService.canEdit();
        this._$scope.$on(toggleEditMode, () => {
            this.isEditMode = !this.isEditMode;
        });
        this._$scope.$watch(() => this.selectedStrategy, (newValue: IApprovalStrategy) => {
            if (!!newValue) {
                this._pristine = angular.copy(newValue);
            }
        });

        this._$scope.$on(strategySaved, () => {
            this._pristine = angular.copy(this.selectedStrategy);
            this._loggerService.logSuccess('Approval strategy successfully updated.', true);
            this.formController.$setPristine();
            this.contextualFormController.$setPristine();
        });
    }
}

export const wtApprovalStrategies: ComponentDefinition = {
    componentId: 'wtApprovalStrategies',
    controller: ApprovalStrategiesController,
    template: require('./approvalStrategies.component.html'),
    controllerAs: 'vm',
    bindings: {
        selectedStrategy: '=?',
        contextualFormController: '=?',
        formController: '=?'
    }
};